import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import ru from './locales/ru.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import uk from './locales/uk.json';
import pt from './locales/pt.json';
import jp from './locales/jp.json';
import snoop from './locales/snoop.json';
import ga from './services/analytics';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'cassette_language'
    },
    resources: {
      en: { translation: en },
      ru: { translation: ru },
      es: { translation: es },
      fr: { translation: fr },
      it: { translation: it },
      uk: { translation: uk },
      pt: { translation: pt },
      ja: { translation: jp },
      jp: { translation: jp },
      snoop: { translation: snoop }
    }
  });

// Log the current language after initialization
// Removed verbose runtime logs
try {
  document.documentElement.lang = i18n.language === 'jp' ? 'ja' : i18n.language;
  ga.setUserProperties({ language: i18n.language });
} catch {}

// Track language changes
i18n.on('languageChanged', (lng) => {
  try {
    document.documentElement.lang = lng === 'jp' ? 'ja' : lng;
    ga.setUserProperties({ language: lng });
    ga.event('language_change', { language: lng });
  } catch {}
});

export default i18n; 